import React from 'react';
import * as S from './style';
import Header from '../Header';
import Footer from '../Footer';
import { useAuth } from 'context/auth';

const Centered = ({
  children,
  image,
  contentProps = {},
  contentBodyProps = {},
  headerProps = {},
  exercise = false,
  ...props
}) => {
  const {
    user: { overlayColor },
  } = useAuth();

  return (
    <S.Wrapper {...props} bgColor={'primaryLight'}>
      <Header exercise={exercise} {...headerProps} />
      <S.Content
        className="scrollable-container"
        bgColor={overlayColor || 'primaryLight'}
        {...contentProps}
      >
        <S.ContentBody {...contentBodyProps} headerType={headerProps.type}>
          {children}
        </S.ContentBody>
      </S.Content>
      <Footer {...props} />
    </S.Wrapper>
  );
};

export default Centered;
